import React, {useContext} from "react";

import styles from "./cardGroup.module.scss";
import {useTranslation} from "react-i18next";
import {AppContext} from "src/pages/context/App.context";

const GroupContainer = (props: any) => {
  const { t } = useTranslation();

  const appCtx:any = useContext(AppContext);
  const headerText =
    `${t(props.header)}` +  `${" (" + props.number + ")"}`;

  return (
    <div>
      <div className={styles.cardGroupHeader}>{headerText}</div>
      {props.children}
    </div>
  );
};

export default GroupContainer;
